import { useState } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import type { PublicationFilter } from "./publicationFilterDefaults";

export type PublicationFilterFieldsValue = Pick<
  PublicationFilter,
  "dr" | "organicKeywords" | "age" | "uniqueSites" | "includeSubdomains"
>;

type NumericFieldKey = "dr" | "organicKeywords" | "age";

export function PublicationFilterFields(props: {
  value: PublicationFilterFieldsValue;
  onChange: <K extends keyof PublicationFilterFieldsValue>(
    key: K,
    value: PublicationFilterFieldsValue[K],
  ) => void;
  disabled: boolean;
}) {
  const [focusedNumericField, setFocusedNumericField] = useState<NumericFieldKey | null>(null);

  function displayNumericValue(field: NumericFieldKey): number | string {
    let displayNumericValueOutcome: number | string;
    const fieldValue = props.value[field];
    if (focusedNumericField === field && fieldValue === 0) {
      displayNumericValueOutcome = "";
    } else {
      displayNumericValueOutcome = fieldValue;
    }
    return displayNumericValueOutcome;
  }

  function parseNumericInput(rawValue: string): number {
    const parsed = Number(rawValue);
    return Number.isNaN(parsed) || parsed < 0 ? 0 : parsed;
  }

  return (
    <>
      <TextField
        label="DR ≥"
        type="number"
        value={displayNumericValue("dr")}
        onChange={(event) => props.onChange("dr", parseNumericInput(event.target.value))}
        onFocus={() => setFocusedNumericField("dr")}
        onBlur={() => setFocusedNumericField(null)}
        disabled={props.disabled}
        size="small"
        slotProps={{ htmlInput: { min: 0 } }}
      />

      <TextField
        label="Organic Keywords ≥"
        type="number"
        value={displayNumericValue("organicKeywords")}
        onChange={(event) =>
          props.onChange("organicKeywords", parseNumericInput(event.target.value))
        }
        onFocus={() => setFocusedNumericField("organicKeywords")}
        onBlur={() => setFocusedNumericField(null)}
        disabled={props.disabled}
        size="small"
        slotProps={{ htmlInput: { min: 0 } }}
      />

      <TextField
        label="Возраст домена ≥ (лет)"
        type="number"
        value={displayNumericValue("age")}
        onChange={(event) => props.onChange("age", parseNumericInput(event.target.value))}
        onFocus={() => setFocusedNumericField("age")}
        onBlur={() => setFocusedNumericField(null)}
        disabled={props.disabled}
        size="small"
        slotProps={{ htmlInput: { min: 0 } }}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={props.value.uniqueSites}
            onChange={(event) => props.onChange("uniqueSites", event.target.checked)}
            disabled={props.disabled}
          />
        }
        label="Уникальные сайты"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={props.value.includeSubdomains}
            onChange={(event) => props.onChange("includeSubdomains", event.target.checked)}
            disabled={props.disabled}
          />
        }
        label="Включать субдомены"
      />
    </>
  );
}
